// extracted by mini-css-extract-plugin
export default {"history":"vk_vl","cardsWrapper":"vk_vm","cardColumn":"vk_vn","cardTitle":"vk_vo","cardRow":"vk_vp","cardRowContainer":"vk_vq","cardName":"vk_vr","card":"vk_mL","cardMain":"vk_vs"};